const RouteConstants = {
    Pages: {
        Error: "error",
        Dashboard: "dashboard",
        ReceiptPage: "receipt"
    }
};

export default RouteConstants;
